import { InteractionDto, InteractionStatus, SupervisorAgentsFilterData } from "@/repository/models";
import { DesireType } from "@/components/molecules/desire";
import { IntlShape } from "react-intl";
import { Availabilities } from "@/components/organisms/currentUserPresence/types";
import { InteractionType } from "@/common/types";

const getInteractionStatusText = (
	status: any,
	intl: IntlShape,
) => {
	if (status == null || status === undefined) {
		return "";
	}

	return intl.formatMessage({
		id: `Common.InteractionStatus.${InteractionStatus[status]}`,
	});
};

export { getInteractionStatusText };

// Generic per-type label used on the second line when there is no contact
// info to show (or when the contact info is deliberately hidden).
export const getInteractionTypeLabel = (
	type: InteractionType,
	intl: IntlShape
): string | undefined => {
	switch (type) {
		case InteractionType.WhatsApp:
			return intl.formatMessage({ id: "Interaction.WhatsAppConversation" });
		case InteractionType.Webchat:
			return intl.formatMessage({ id: "Interaction.WebchatConversation" });
		case InteractionType.Call:
			return intl.formatMessage({ id: "Interaction.VoiceInteraction" });
		case InteractionType.Email:
			return intl.formatMessage({ id: "Interaction.EmailInteraction" });
		default:
			return undefined;
	}
};

// Second line shown under the customer name: the contact info when available
// (and not just repeating the name), otherwise the generic per-type label.
export const getInteractionSecondaryInfo = (
	interaction: Pick<InteractionDto, "type"> &
		Partial<Pick<InteractionDto, "name" | "contactInformation">>,
	intl: IntlShape
): string | undefined => {
	if (
		!!interaction.contactInformation &&
		interaction.contactInformation !== interaction.name
	) {
		return interaction.contactInformation;
	}

	return getInteractionTypeLabel(interaction.type, intl);
};

export const desireTypes: DesireType[] = Object.keys(DesireType)
	.map(Number)
	.filter((key: number) => !isNaN(key))
	.map((x: number) => x as DesireType)
	.reverse();

export const desireColors: Record<string, string> = {
	[DesireType.High]: "#5b5fc7",
	[DesireType.Normal]: "#9299f7",
	[DesireType.Low]: "#c8b4ff",
};

export const desireName = (type: DesireType, intl: IntlShape) =>
	intl.formatMessage({ id: `Supervisor.Desire.${DesireType[type]}` });

export const initialSupervisorFilterAvailabilityList = [
	Availabilities.Available,
	Availabilities.Busy,
	Availabilities.DND,
	Availabilities.BeRightBack,
	Availabilities.Away,
];

export const castStringToBoolean = (value: string) => {
	switch (value) {
		case "true":
			return true;
		case "false":
			return false;
		default:
			return null;
	}
};

export const getInitialSupervisorFilterData = () => {
	return {
		queueIds: [],
		searchText: "",
		isOnline: null,
		hasClient: null,
		isJoined: null,
		presences: [],
		desire: [],
	} as SupervisorAgentsFilterData;
};

export const getNumberOfFilters = (
	supervisorAgentsFilterState: SupervisorAgentsFilterData
) => {
	const radioFilterNumber = [
		supervisorAgentsFilterState.isOnline,
		supervisorAgentsFilterState.hasClient,
		supervisorAgentsFilterState.isJoined,
	].filter((x) => x != null).length;

	const listFilterNumber = [
		supervisorAgentsFilterState.presences?.length > 0,
		supervisorAgentsFilterState.desire?.length > 0,
	].filter((x) => x !== false).length;

	return radioFilterNumber + listFilterNumber;
};
